import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import ResolveHeader from 'components/ResolveHeader';
import ResolveImage from 'components/ResolveImage';
import Image from 'assets/images/cloud-and-lock.webp';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LinkToIcon from 'icons/LinkTo.icon';
import AuthContext from 'providers/Auth/Auth.context';
import PrivateListingLandingForm from './components/PrivateListingLandingForm';
import api from 'api';
import { Listing } from 'models/Listing';
import ListingCardOnPrivateListingLanding from './components/ListingCardOnPrivateListingLanding';
import SuccessScreen from './components/SuccessScreen';
import { BUSINESS_ROUTE, LOGIN_ROUTE } from 'data/global';

import './PrivateListingLanding.styles.scss';
import './PrivateListingLanding.styles.responsive.scss';

const LIMIT = '4';

type PrivateListingLandingProps = {
  className?: string;
};

const PrivateListingLanding: React.FC<PrivateListingLandingProps> = (props) => {
  const { className } = props;

  const [listings, setListings] = useState<Listing[]>([]);
  const [showSuccessScreen, setShowSuccessScreen] = useState(false);

  const { isLoggedIn } = useContext(AuthContext);

  const classes = classNames('private-listing-landing', className);

  const { t } = useTranslation();

  useEffect(() => {
    (async () => {
      try {
        const {
          data: { items },
        } = await api.listings.getListings({
          $limit: LIMIT,
        });

        setListings(items);
      } catch (e) {
        return;
      }
    })();
  }, []);

  return (
    <div className={classes}>
      <ResolveHeader />

      {showSuccessScreen ? (
        <SuccessScreen />
      ) : (
        <main>
          <div>
            <ResolveImage src={Image} asIllustration />

            <h1>{t('privateListingTitle')}</h1>

            <p className="description">
              {t('privateListingDescription')}
              <Link to={BUSINESS_ROUTE}>
                {t('visitOurPublicMarketplace')}
                <LinkToIcon />
              </Link>
            </p>

            <p className="thanks">{t('privateListingThanks')}</p>
            {!isLoggedIn && (
              <Link to={LOGIN_ROUTE} className="link-to-login">
                {t('resolveAccountLogIn')}
              </Link>
            )}

            <PrivateListingLandingForm
              onSuccess={() => setShowSuccessScreen(true)}
            />
          </div>

          {!!listings.length && (
            <div className="white-panel">
              <h2>{t('publicListings')}</h2>
              {listings.map((listing) => (
                <ListingCardOnPrivateListingLanding
                  key={listing._id}
                  listing={listing}
                />
              ))}
            </div>
          )}
        </main>
      )}
    </div>
  );
};

export default PrivateListingLanding;
